import camelcaseToKebabcase from '../../utils/camelcase-to-kebabcase';

const legacyNameUtil = {
  get(addressType, prefix, name) {
    let actualName;
    if (name === 'streetName') {
      actualName = 'street-address-2';
    } else if (name === 'addressLine2') {
      actualName = 'address-locality';
    } else if (name === 'postCode') {
      actualName = 'postcode';
    } else {
      actualName = name;
    }

    actualName = camelcaseToKebabcase(actualName);
    const nameInClass = ` ${actualName}-field ${addressType}-${actualName}-field`;

    let id;
    switch (name) {
      case 'county':
        id = `${addressType}-state-province`;
        break;
      case 'postCode':
        id = `${addressType}-post-zip-code`;
        break;
      case 'addressLine2':
        id = `${addressType}-address-line-2`;
        break;
      default:
        id = `${addressType}-${camelcaseToKebabcase(name)}`;
    }
    
    const nameOnForm = `${prefix + addressType}Address.${name}`;

    return {
      id,
      nameInClass,
      wrappedClassName: actualName,
      nameOnForm,
    };
  },
};

export default legacyNameUtil;
